"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationsService = void 0;
class NotificationsService {
    httpRequest;
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * @returns NotificationResponseDto The list of records associated with the user.
     * @throws ApiError
     */
    findAllByUser({ page, limit, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/notifications/v1/notifications/user',
            query: {
                'page': page,
                'limit': limit,
            },
        });
    }
    /**
     * @returns NotificationResponseDto The list of records associated with the space.
     * @throws ApiError
     */
    findAllBySpace({ spaceId, page, limit, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/notifications/v1/notifications/space/{spaceId}',
            path: {
                'spaceId': spaceId,
            },
            query: {
                'page': page,
                'limit': limit,
            },
        });
    }
    /**
     * @returns NotificationResponseDto Update notification.
     * @throws ApiError
     */
    readNotification({ id, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/notifications/v1/notifications/read-notification/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns ManyNotificationResponseDto The record has been successfully created.
     * @throws ApiError
     */
    sendMany({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/notifications/v1/notifications/send-many',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns NotificationResponseDto The record has been successfully created.
     * @throws ApiError
     */
    send({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/notifications/v1/notifications/send',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
exports.NotificationsService = NotificationsService;
